import { ApiEndpointHandler } from '@sonar-software/sonar-http';

import { patchInitiatives, PatchInitiativesRequest } from './patchInitiatives';

export type PatchInitiativeByIdRequest = Omit<PatchInitiativesRequest, 'initiativeIds'> & {
	initiativeId: number;
};

export const patchInitiativeById: ApiEndpointHandler<PatchInitiativeByIdRequest> = (request, options) =>
	patchInitiatives({
		initiativeIds: [ request.initiativeId ],
		patchInitiativeDescription: request.patchInitiativeDescription
	}, options);
